import React, { useState, useRef } from "react";
import "./ImageUpload.css";
import pdf from "../assets/pdf.png";

const ImageUpload = ({
  onImageUpload,
  acceptedFormats = "image/*,application/pdf",
  allowedTypes = [
    "image/jpeg",
    "image/png",
    "image/gif",
    "application/pdf",
  ],
  defaultMessage = "Click here to upload",
  imgData,
  imgstatus,
  toast,
  warnmsg,
  imageStatusChange,
  userData,
  checkRoleStatus
}) => {

  console.log("imgstatus",imgstatus);

const handleStatusChange =(value)=>{
  imageStatusChange(value);
}
 
  const [selectedImage, setSelectedImage] = useState(imgData || null);
  const fileInputRef = useRef();

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    if (file && allowedTypes.includes(file.type)) {
      setSelectedImage({
        url: URL.createObjectURL(file),
        name: file.name,
        type: file.type,
      });
      onImageUpload(file);
      imageStatusChange("0");
    } else {
      toast.error(warnmsg);
    }
  };

  const handleUploadButtonClick = () => {
    if(imgstatus !== "1"){
      fileInputRef.current.click();
   }
   else if(imgstatus === "1"){
    toast.info("You can't change profile image contact your admin");
   }
  };

  const handleDragEnter = (e) => e.preventDefault();
  const handleDragOver = (e) => e.preventDefault();
  const handleDragLeave = (e) => e.preventDefault();

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file && allowedTypes.includes(file.type)) {
      const fileUrl = URL.createObjectURL(file);
      setSelectedImage({ url: fileUrl, name: file.name, type: file.type });
      onImageUpload(file);
    } else {
      alert("Unsupported file type. Please upload an image or PDF.");
    }
  };

  return (
    <div className="image-upload-container pr ofh">
      <div
        className="image-preview"
        onDragEnter={handleDragEnter}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={handleUploadButtonClick}
        style={{
          cursor: "pointer",
          border: selectedImage?.url ? "2px solid #ccc" : "2px dashed #ccc",
          padding: selectedImage?.url ? "20px" : "20px",
          backgroundColor: selectedImage?.url ? "transparent" : "#f9f9f9",
          maxWidth: "320px",
          minWidth: "100%",
          height: "160px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {selectedImage?.url ? (
          <>
            {selectedImage.type === "application/pdf" ? (
              <img
                src={pdf}
                alt={selectedImage.name}
                style={{ maxWidth: "100%", maxHeight: "100%" }}
              />
            ) : (
              <img
                src={selectedImage.url}
                alt={selectedImage.name}
                style={{ maxWidth: "100%", maxHeight: "100%" }}
              />
            )}

            {imgstatus === "1" ?(
            <div className="status-img pa bg-green badge-status badge box-center">
              Approved
            </div>
            ):imgstatus === "2" ?(
            <div className="status-img pa bg-red badge-status badge box-center">
              Rejected
            </div>
            ):(
              <div className="status-img pa bg-orange badge-status badge box-center">
              Pending
            </div>
            )}

            <div className="image-overlay">
              <p>{selectedImage.name}</p>
            </div>
          </>
        ) : (
          <p className="box-center">{defaultMessage}</p>
        )}
      </div>
      <input
        ref={fileInputRef}
        type="file"
        accept={acceptedFormats}
        style={{ display: "none" }}
        onChange={handleFileInputChange}
      />
     
        
        <div className="v-center mt8">
          {checkRoleStatus>0 && selectedImage && <label className="radio-label cp mr10">
            <input
              type="radio"
              value="1"
              checked={imgstatus === "1"}
              onChange={(e) => handleStatusChange(e.target.value)}
              className="mr4"
            />
            Approve
          </label>}
          {checkRoleStatus>0 && selectedImage && <label className="radio-label cp">
            <input
              type="radio"
              value="2"
              checked={imgstatus === "2"}
              onChange={(e) => handleStatusChange(e.target.value)}
              className="mr4"
            />
            Reject
        </label>}
        {checkRoleStatus>0 && selectedImage && <label className="radio-label cp ml12">
            <input
              type="radio"
              value="0"
              checked={imgstatus === "0"}
              onChange={(e) => handleStatusChange(e.target.value)}
              className="mr4"
            />
            Pending
        </label>}
       
        {selectedImage && <button
            onClick={() => window.open(selectedImage.url, "_blank")}
            className="ls1 fs14 fc1 tdu ml12"
          >
            View
          </button>}

          {/* Uncomment this if you want to enable the Remove button */}
          {/* <button
            onClick={() => {
              setSelectedImage(null);
              onImageUpload(null); 
            }}
            className="ls1 tdu fs14"
          >
            Remove
          </button> */}
        </div>


      
    </div>
  );
};

export default ImageUpload;
